import { Options } from "highcharts";

export const CertChartOptions: Options = {
  chart: {
    type: "packedbubble",
    spacingTop: 0,
    spacingRight: 0,
    spacingBottom: 0,
    spacingLeft: 0,
    plotBorderWidth: 0,
    margin: [0, 0, 0, 0],
    height: "100%",
  },
  lang: {
    noData: "",
  },
  title: {
    text: "",
  },
  loading: {
    labelStyle: { backgroundImage: "/assets/images/icons/loader.svg" },
  },
  navigation: {
    buttonOptions: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: ["#4FB3CF", "#7AC5DA", "#A7D9E7"], //["#ff0000", "#0ff000", "#00ff00", "#000ff0", "#0000ff"],
  plotOptions: {
    packedbubble: {
      // minSize: "50px",
      // maxSize: "100%",
      maxSize: "100%",
      minSize: "50px",
      sizeBy: "value",
      layoutAlgorithm: {
        gravitationalConstant: 0.02,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        filter: {
          property: "y",
          operator: ">",
          value: 5,
        },
        style: {
          color: "white",
          textOutline: "none",
          fontWeight: "bold",
          fontFamily: "Proxima, sans-serif",
          fontSize: "12px",
        },
      },
      marker: {
        fillOpacity: 1,
      },
    },
  },
  tooltip: {
    useHTML: true,

    formatter: function () {
      let childtooltip = "";
      if (this.point !== undefined && this.point !== null) {
        if (this.point.name && this.point.options.value) {
          childtooltip = `<b>${this.point.name}:</b> ${this.point.options.value}`;
        }
      }
      if (childtooltip === "") {
        const options = this.series.options as any;
        return `<b>${this.series.name}:</b> ${options.value}<br>`;
      } else {
        return `${childtooltip}`;
      }
    },
  },
  series: [{ name: "", type: "packedbubble", data: [] }],
};
